import React from 'react';
import { Link } from 'react-router-dom';

import { AskCoPilotView } from '@copilot/ui';
import Loader from '../components/common/Loader';
import * as memoryApi from '../services/memoryApi';

const renderLink = ({ href, className, children }) => (
  <Link to={href} className={className || undefined}>
    {children}
  </Link>
);

const meetingHref = (meetingId) => `/app/meeting/${meetingId}`;

// Ask KrishvaQ - @copilot/ui's AskCoPilotView, shared with Desktop, wired
// to Web's memory API and routes.
function AskCoPilotPage() {
  return (
    <AskCoPilotView
      api={memoryApi}
      meetingHref={meetingHref}
      renderLink={renderLink}
      loadingIndicator={<Loader label="Searching meeting memory..." />}
    />
  );
}

export default AskCoPilotPage;
